import HeroSection from "./components/HeroSection";
import VideosSection from "./components/VideosSection";
import SistemasSection from "./components/SistemasSection";
import BonosSection from "./components/BonosSection";
import TestimoniosFaqSection from "./components/TestimoniosFaqSection";

export default function Home() {
  return (
    <main className="bg-[#080808] overflow-x-hidden">
      <HeroSection />
      <VideosSection />
      <SistemasSection />
      <BonosSection />
      <TestimoniosFaqSection />
    </main>
  );
}
